"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Shop = function (props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-513",
    d: "M14,34c0-1.914,0.949-2.841,3.077-3.003l26.765-2.059L47.205,11H11.97L9.813,4.261l-7.419-3.18L1.606,2.919l6.581,2.82 l7.507,23.459C13.304,29.768,12,31.434,12,34c0,2.935,2.392,4,4,4h29v-2H16C15.666,36,14,35.903,14,34z M44.795,13l-2.637,14.062 l-24.446,1.881L12.61,13H44.795z M21,39c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4S23.206,39,21,39z M21,45 c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S22.103,45,21,45z M37,39c-2.206,0-4,1.794-4,4s1.794,4,4,4s4-1.794,4-4 S39.206,39,37,39z M37,45c-1.103,0-2-0.897-2-2s0.897-2,2-2s2,0.897,2,2S38.103,45,37,45z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-513"
  }));
};